import { Delta } from "quill/core";

export const jobCreateSummaryInitialState = {
  summaryEditors: {
    crewSummary: new Delta(),
    adminSummary: new Delta(),
    customerSummary: new Delta(),
    summaryIndex: 0 as number,
  },
} as const;

export type JobCreateSummaryState = typeof jobCreateSummaryInitialState;
